
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44","height":"44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 8497","fill":"none"}},[_c('path',{attrs:{"data-name":"Rectangle 4208","d":"M0 0h44v44H0z"}}),_c('g',{attrs:{"data-name":"hair dryer","transform":"translate(-283.5 -1317.5)","stroke":"#109a50","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"data-name":"Path 7797","d":"M321.105 1325.391h-8.138a8.97 8.97 0 01-5.74-2.232 11.412 11.412 0 10-.153 17.631 9.9 9.9 0 016.2-2.357h7.835a1.631 1.631 0 001.63-1.63v-9.782a1.631 1.631 0 00-1.634-1.63z"}}),_c('path',{attrs:{"data-name":"Path 7798","d":"M304.804 1342.215v14.151a1.635 1.635 0 01-1.63 1.63h-3.277a1.632 1.632 0 01-1.63-1.614c-.114-5.494-.913-10.678-2.771-13.939"}}),_c('circle',{attrs:{"data-name":"Ellipse 509","cx":"5","cy":"5","r":"5","transform":"translate(295.117 1326.5)"}})])])])
          )
        }
      }
    